import { PdfReportType } from '@api/requests';
import { useState } from 'react';

export const STORAGE_KEYS = {
  reportReadyShown: 'reportReadyShown',
  waitingForRedirectResponse: 'waitingForRedirectResponse',
  isAnalysingReport: 'isAnalysingReport',
  analysingReportId: 'analysingReportId',
  isFamilyTreeWelcomeShown: 'isFamilyTreeWelcomeShown',
  reportReadyPopupShown: (type: PdfReportType) => `${type}_ReportShown`,
  seenFirstEntry: 'seenFirstEntry',
  seenFirstEntryFaceMatch: 'seenFirstEntryFaceMatch',
  seenFirstEntryLookalike: 'seenFirstEntryLookalike',
  restorationId: 'restorationId',
  restoredPhotoPopupShown: 'restoredPhotoPopupShown',
  onboardingRestorationId: 'onboardingRestorationId',
  reviewModalShown: 'reviewModalShown',
};

export const useLocalStorage = <T>(
  key: string,
  defaultValue: T,
): [T, (value: T | ((prevState: T) => T)) => void] => {
  const getStoredValue = (): T => {
    const value =
      typeof window !== 'undefined' ? localStorage.getItem(key) : null;
    if (value) {
      return JSON.parse(value) as T;
    } else {
      return defaultValue;
    }
  };

  const [state, setState] = useState<T>(getStoredValue());

  const setStoredValue = (value: T | ((prevState: T) => T)) => {
    setState(prevState => {
      const newValue =
        typeof value === 'function'
          ? (value as (prevState: T) => T)(prevState)
          : value;

      if (typeof window !== 'undefined') {
        if (newValue === undefined) {
          localStorage.removeItem(key);
        } else {
          localStorage.setItem(key, JSON.stringify(newValue));
        }
      }

      return newValue;
    });
  };

  return [state, setStoredValue];
};
